import { createThunk, model, Model } from 'mst-collection';
import { getRoot, types } from 'mobx-state-tree';

import { Api } from '@api';
import { SkillLevelQuestionnaireAnswerListModel } from './SkillLevelQuestionnaireAnswerListModel';
import { useRoot } from '../useRoot';
import type { RootModelType } from '../RootModel';
import type { ICurrentUser } from '../Viewer/UserModel';
import type { UserSettings } from '../Viewer/UserSettingsModel';

export class SkillLevelQuestionnaire extends Model({
  list: types.optional(SkillLevelQuestionnaireAnswerListModel, {}),
  question: types.maybeNull(types.string),
  selectedAnswerId: types.maybeNull(types.number),
}) {
  setQuestion(question: string) {
    this.question = question;
  }

  setSelectedAnswer(answerId: number) {
    this.selectedAnswerId = answerId;
  }

  get canBeSaved() {
    return this.selectedAnswerId !== null;
  }

  private get _userSettings(): UserSettings {
    return (
      getRoot<RootModelType>(this).viewer.currentUser as ICurrentUser
    ).settings;
  }

  fetch = createThunk(() => {
    return async function fetch(this: SkillLevelQuestionnaire) {
      const res = await Api.Profile.getSkillLevelQuest();

      this.setQuestion(res.data.question);
      this.list.set(res.data.answers);
    };
  });

  save = createThunk(() => {
    return async function save(this: SkillLevelQuestionnaire) {
      const selectedAnswer = this.list.array.find(
        (answer) => answer.id === this.selectedAnswerId,
      );

      if (!selectedAnswer) {
        return;
      }

      await Api.Profile.setSkillLevel({
        skillLevel: selectedAnswer.value,
      });
      this._userSettings.setSkillLevel(selectedAnswer.value);
    };
  });
}

export const SkillLevelQuestionnaireModel = model(
  SkillLevelQuestionnaire,
);

export function useSkillLevelQuestionnaireModel() {
  const root = useRoot();
  return root.skillLevelQuestionnaire;
}
